import Vue from 'vue'
import Router from 'vue-router'
 
Vue.use(Router)
 
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('./layout/index.vue'),
      children: [
        {
          path: '/',
          name: 'homepage',
          component: () => import('./pages/homepage/index.vue'),
        },
        {
          path: '/partners',
          name: 'partners',
          component: () => import('./pages/partners/index.vue'),
        },
        {
          path: '/aboutus',
          name: 'aboutus',
          component: () => import('./pages/aboutus/index.vue'),
        },
        {
          path: '/exhibition',
          name: 'exhibition',
          component: () => import('./pages/exhibition/index.vue'),
        },
        {
          path: '/products',
          name: 'products',
          component: () => import('./pages/products/index.vue'),
        },
        {
          path: '/productDetail',
          name: 'productDetail',
          component: () => import('./pages/products/detail.vue'),
        }
      ]
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: () => import('./pages/contactus/index.vue'),
    },
  ]
})